import { NeutralColors } from 'portfolio3/styles';
import { SxStyles } from 'types';

export const popupBody: SxStyles = {
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: NeutralColors.light_neutrals_0,
  borderRadius: '16px',
  padding: '24px',
  gap: '24px',
};

export const popupTypography: SxStyles = {
  color: '#0A0B0F',
};

export const popupImg: SxStyles = {
  width: '104px',
  height: '104px',
};

export const popupInnerBody: SxStyles = {
  padding: '24px',
  background: '#F3F4F9',
};
